import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from '../../shared/services/alert.service';
import {ArticleCategoryService} from '../../shared/services/article-category.service';

@Component({
    selector: 'app-article-blog-categories',
    templateUrl: './article-categories.component.html',
    styleUrls: ['./article-categories.component.scss']
})
export class ArticleCategoriesComponent implements OnInit {
    showSearch = false;
    id: any;
    data: any;
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    articleCategories = [];
    onFileChanged: any;

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private articleCategoryService: ArticleCategoryService,
                private alertService: AlertService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('app-add-article-category').toggleOpen();
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'name': ['']
        });
        this.get();
    }


    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({page: 1, total: null, perpage: 15, pages: null});
            this.toggleSidebar();
        }
    }

    onFileChange(e, type, data) {
        this.onFileChanged = e;
        this.articleCategoryService.fileUploadAdmin({
            'type': type,
            'fileType': 'NORMAL',
            'insight_id': data.id
        }, this.onFileChanged).subscribe(data => {
            if (type === 'ARTICLE_CATEGORY_BANNER') {
                if (data && data['data']) {
                    this.get();
                }
            }
            this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
        }, error => {
            this.alertService.showErrors('Something went wrong, please try again');
        });
    }

    openInsightBanner(data) {
        window.open(data['article_category_banner']['url'], '_blank');
    }

    search() {
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : ''
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            name: (this.searchForm && this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
        };
        this.get(params);
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.articleCategories = [];
        this.articleCategoryService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.articleCategories = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.articleCategories = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    updateStatus(data, status) {
        this.articleCategoryService.updateStatus(data.id, {'status': status}).subscribe(data => {
            this.submitting = false;
            this.submitted = false;
            this.get();
        }, error => {
            this.submitting = false;
            this.submitted = false;
        });
    }

    delete(id) {
        this.articleCategoryService.delete(id).subscribe(data => {
            this.get();
        });
    }
}
